import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Color, Euler, Vector3 } from 'three';
import { computed } from 'vue';
import type { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SundialFaceGrid',
  props: {
    sundialRotation: {
        required: true,
        type: Object as PropType<Euler>
    },
    show:{
        required: true,
        type: Boolean as PropType<boolean>
    },
    origin: {
        required: true,
        type: Object as PropType<Vector3>
    },
    radius: {
        required: true,
        type: Number as PropType<number>
    },
    colorPalette: {
        required: true,
        type: String as PropType<"dark" | "light">
    }
},
  setup(__props) {

const props = __props

const size = computed(() => props.radius * 2);
const minorLineDivisions = computed(() => size.value*10);
const majorLineDivisions = computed(() => size.value)

const minorLineGridHelperArgsLight = computed(() => [size.value, minorLineDivisions.value, new Color("#909090"), new Color("#909090")] as const)
const majorLineGridHelperArgsLight = computed(() => [size.value, majorLineDivisions.value, new Color("#666666"), new Color("#666666")] as const)

const minorLineGridHelperArgsDark = computed(() => [size.value, minorLineDivisions.value, new Color("#909090"), new Color("#909090")] as const)
const majorLineGridHelperArgsDark = computed(() => [size.value, majorLineDivisions.value, new Color("#ffffff"), new Color("#ffffff")] as const)

const lightGridsVisible = computed(() => props.colorPalette == "light" && props.show)
const darkGridsVisible = computed(() => props.colorPalette == "dark" && props.show)




return (_ctx: any,_cache: any) => {
  const _component_TresGridHelper = _resolveComponent("TresGridHelper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TresGridHelper, {
      visible: lightGridsVisible.value,
      args: minorLineGridHelperArgsLight.value,
      position: props.origin,
      rotation: props.sundialRotation
    }, null, 8, ["visible", "args", "position", "rotation"]),
    _createVNode(_component_TresGridHelper, {
      visible: lightGridsVisible.value,
      args: majorLineGridHelperArgsLight.value,
      position: props.origin,
      rotation: props.sundialRotation
    }, null, 8, ["visible", "args", "position", "rotation"]),
    _createVNode(_component_TresGridHelper, {
      visible: darkGridsVisible.value,
      args: minorLineGridHelperArgsDark.value,
      position: props.origin,
      rotation: props.sundialRotation
    }, null, 8, ["visible", "args", "position", "rotation"]),
    _createVNode(_component_TresGridHelper, {
      visible: darkGridsVisible.value,
      args: majorLineGridHelperArgsDark.value,
      position: props.origin,
      rotation: props.sundialRotation
    }, null, 8, ["visible", "args", "position", "rotation"])
  ], 64))
}
}

})